// The footer, on every page including the game screens: three small links, in
// alphabetical order, and nothing else.
//
// The TMDB notice used to sit here, in full, on every page. It does not need to:
// their API terms ask for it "prominently in or on Your Application" and their
// developer FAQ puts it in an "About" or "Credits" section. A paragraph repeated
// under every screen was the largest thing on the page that nobody reads, and on
// a phone it was what pushed the board off the bottom. Now it is on /about, with
// the logo, and this is the link that reaches it from everywhere.
import { Link } from 'react-router-dom';
import './SiteFooter.css';

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <hr className="rule" />
      <nav className="site-footer-links">
        <Link to="/about">About</Link>
        <span aria-hidden="true">·</span>
        <Link to="/contact">Contact</Link>
        <span aria-hidden="true">·</span>
        <Link to="/privacy">Privacy</Link>
      </nav>
    </footer>
  );
}
